import { BulkDeleteConfirmDialog } from "@/action-dialog/dialogs/BulkDeleteConfirmDialog";
import type { UnifiedItem } from "@/pages/workspaces/types";
import type { Canvas, FileRecord, InboxItem } from "@cohesive/api-client";
import { useRef } from "react";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type BulkDeleteCallableProps = {
  items: UnifiedItem[];
  onDeleteCanvas: (canvas: Canvas) => Promise<void>;
  onDeleteFileRecord: (record: FileRecord) => Promise<void>;
  onDeleteChat?: (chat: InboxItem) => Promise<void>;
};

export const BulkDeleteCallable = createCallable<
  BulkDeleteCallableProps,
  boolean
>(({ call, items, onDeleteCanvas, onDeleteFileRecord, onDeleteChat }) => {
  const succeededRef = useRef(false);

  return (
    <BulkDeleteConfirmDialog
      items={items}
      onDeleteCanvas={onDeleteCanvas}
      onDeleteFileRecord={onDeleteFileRecord}
      onDeleteChat={onDeleteChat}
      onClose={() => {
        call.end(succeededRef.current);
        succeededRef.current = false;
      }}
      onSuccess={() => {
        succeededRef.current = true;
      }}
    />
  );
}, UNMOUNTING_DELAY_MS);

BulkDeleteCallable.displayName = "BulkDeleteCallable";
